"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal = require("react-modal");
require("./ClosedOrderModal.scss");
// todo: get dutch messages
var MODAL_MESSAGES = {
    APPROVE: 'Er zijn uren geboekt op de volgende gesloten orders. Heropenen is vereist om goed te kunnen keuren.',
    CONTROL: 'Er zijn uren geboekt op de volgende gesloten orders. Heropenen is vereist om goed te kunnen keuren.'
};
var MODE_CONTROL = 'CONTROL';
var MODE_APPROVE = 'APPROVE';
var ClosedOrderModal = /** @class */ (function (_super) {
    __extends(ClosedOrderModal, _super);
    function ClosedOrderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.initialState();
        Modal.setAppElement('#application');
        return _this;
    }
    ClosedOrderModal.prototype.openModal = function (mode) {
        this.setState({
            open: true,
            mode: mode ? mode : this.state.mode,
        });
    };
    ClosedOrderModal.prototype.initialState = function () {
        return {
            open: false,
            mode: MODE_APPROVE,
        };
    };
    ClosedOrderModal.prototype.render = function () {
        var _this = this;
        return (React.createElement(Modal, { isOpen: this.state.open, className: "search-projects-modal approve-modal" },
            React.createElement("div", { id: "approve-modal-content" },
                React.createElement("div", { className: "margin-16" }),
                React.createElement("div", { className: "approve-message" },
                    this.state.mode === MODE_CONTROL ? MODAL_MESSAGES.CONTROL : MODAL_MESSAGES.APPROVE,
                    this.props.orders && (React.createElement("ul", null, this.props.orders.map(function (item, index) { return (React.createElement("li", { key: index }, item)); })))),
                React.createElement("div", { className: "margin-16" }),
                React.createElement("div", { className: "buttons-container row" },
                    React.createElement("button", { className: "button", onClick: function () {
                            _this.setState(_this.initialState());
                            if (_this.state.mode === MODE_CONTROL) {
                                _this.props.onControl();
                            }
                            else {
                                _this.props.onApprove();
                            }
                        } }, this.state.mode === MODE_CONTROL ? 'Controleren' : 'Goedkeuren'),
                    React.createElement("div", { className: "margin-8" }),
                    React.createElement("span", { className: "button button-default", onClick: function () {
                            _this.setState(_this.initialState());
                        } }, "Annuleer")))));
    };
    return ClosedOrderModal;
}(React.Component));
exports.default = ClosedOrderModal;
